import { render, staticRenderFns } from "./ScheduleDeliverySettings.vue?vue&type=template&id=36c5cfa0&scoped=true&"
import script from "./ScheduleDeliverySettings.vue?vue&type=script&lang=js&"
export * from "./ScheduleDeliverySettings.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDeliverySettings.vue?vue&type=style&index=0&id=36c5cfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5cfa0",
  null
  
)

export default component.exports